import query from "./query/es";
export default {
  label: "Grupos",
  createGroup: "Crear Grupo",
  updateGroup: "Actualizar Grupo",
  groupDetails: "Detalles del Grupo",
  query,
};
